import gql from 'graphql-tag'

export const LOGIN_MUTATION = gql`
    mutation login($input: LoginInput){
        login(input: $input){
            access_token
            refresh_token
            expires_in
            token_type
            user {
                id
                name
                email
                role_id     
            }
        }
    }
`

export const LOGOUT_MUTATION = gql`
    mutation logout {
        logout {
            status
            message
        }
    }
`
